import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import React, { useMemo } from "react";
import { AEMoment } from "../moment";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { AERole } from "../AERole";
import { roles } from "../../../index";
import { AESVG } from "../svg";
import { AEButton } from "../buttons";
import { AERating } from "../rating";

import { useState } from "react";

import EditableFeedMessage from "./EditableFeedMessage";

import useFeedForm from "../../hooks/useFeedForm";
import { AERater } from "../../../_metronic/_partials/controls/forms/AERater";
import FeedActions from "./FeedActions";
import FeedActionButtons from "./FeedActionButtons";

export const EditableFeed = ({
  entity, //parent entity
  updateCallback,
  isAuthor = false,

  getEntity,
  ReviewActions, //actions to dispatch
  authUser, //authenticated user
  idField, //id field to edit
  selectedFeed,
  setSelectedFeed,
  feedId, //id of the feed
}) => {
  const dispatch = useDispatch();
  const [editFeed, setEditFeed] = useState(false); //TODO refactor use editableId only
  // const [editRating, setEditRating] = useState(false);
  // const [selected, setSelected] = useState(false);

  const { formatMessage } = useIntl();
  const user = useSelector((s) => s["auth"].user);

  const { id, created_by, message, created_at, enabled, rating } = entity;
  const editReviewFormik = useFeedForm({
    entity,
    dispatch,
    authUser,
    getEntity,
    idField,
    ReviewActions,
    edit: true,
    feedId,
    initialData: { message, rating },
    setSelectedFeed,
    setEditFeed,
  });
  const { handleSubmit, getFieldProps } = editReviewFormik;
  // const canUpdate = useMemo(
  //   () => user.id === entity.user_id || user.roles.includes(roles.super_admin),
  //   [entity.user_id, user.id, user.roles]
  // );
  const canUpdate = useMemo(
    () => Number(user.id) === Number(entity.user_id) || user.roles.includes(roles.super_admin),
    [entity.user_id, user.id, user.roles]
  );

  return (
    <div className="d-flex pt-5">
      <div className="symbol symbol-40 symbol-light-success mr-5 mt-1">
        <span className="symbol-label">
          <img
            src={toAbsoluteUrl("/media/svg/avatars/009-boy-4.svg")}
            className="h-75 align-self-end"
            alt=""
          />
        </span>
      </div>
      <div className="d-flex flex-column flex-row-fluid">
        <div className="d-flex align-items-center flex-wrap">
          <a
            href="#"
            className={`text-dark-75 text-hover-primary font-size-lg font-weight-bolder pr-2 ${isAuthor ? "text-primary" : ""
              }`}
          >
            {created_by.username}
          </a>
          {rating !== undefined &&
            (selectedFeed !== id ? (
              <AERating value={rating} />
            ) : (
              <AERater
                field={getFieldProps("rating")}
                form={editReviewFormik}
                borderless
                muliple
                withFeedbackLabel={false}
                validation={false}
                name={"rating"}
                label={"RATING"}
                placeholder={formatMessage({ id: "MESSAGE" })}
                raterKey={id}
              />
            ))}
          {/* {isAuthor && (
            <small className="text-primary pr-2">
              {formatMessage({ id: "AUTHOR" })}
            </small>
          )} */}
          {selectedFeed === id && (
            <>
              <FeedActionButtons
                entity={entity}
                setSelectedFeed={setSelectedFeed}
                handleSubmit={handleSubmit}
                message={message}
                feedId={id}
              />
            </>
          )}
          {updateCallback && (
            <AERole accept={[roles.super_admin]}>
              {
                <AEButton variant={"link"} icon onClick={updateCallback}>
                  <AESVG
                    path={`/General/${enabled ? "Visible" : "Hidden"}.svg`}
                    variant={"danger"}
                    className={"pr-2"}
                  />
                </AEButton>
              }
            </AERole>
          )}

          <AEMoment
            date={created_at}
            className="text-muted font-weight-normal font-size-sm pr-2 ml-auto"
          />

          <FeedActions
            canUpdate={canUpdate}
            feedId={id}
            actions={ReviewActions}
            getEntity={getEntity}
            setEditFeed={setEditFeed}
            setSelectedFeed={setSelectedFeed}
            isAuthor={isAuthor}
          />
        </div>
        <EditableFeedMessage
          editFeed={selectedFeed === id}
          message={message}
          getFieldProps={getFieldProps}
        />
      </div>
    </div>
  );
};
